<script setup lang="ts">
import { CollapsibleTrigger, type CollapsibleTriggerProps } from 'radix-vue'

const props = defineProps<CollapsibleTriggerProps>()
</script>

<template>
	<collapsible-trigger v-bind="props">
		<slot />
	</collapsible-trigger>
</template>
